import { APP_URL, PRIVY_SECURITY_URL } from '../../constants';
import { useLanguage } from '../../i18n/LanguageContext';

function TrustSection() {
    const { t } = useLanguage();

    return (
        <>
            <section className="home-sec" id="trust">
                <div className="wrap">
                    <div className="why">
                        <a className="panel rv" href={PRIVY_SECURITY_URL} target="_blank" rel="noreferrer" style={{ '--rv-delay': '0ms' }}>
                            <span className="eyebrow">{t.trustPrivyEyebrow}</span>
                            <h3>{t.trustPrivyTitle}</h3>
                            <p>{t.trustPrivyText}</p>
                            <span className="more">{t.trustPrivyLink}</span>
                        </a>
                        <a className="panel rv" href={APP_URL} style={{ '--rv-delay': '90ms' }}>
                            <span className="eyebrow">{t.trustAccessEyebrow}</span>
                            <h3>{t.trustAccessTitle}</h3>
                            <p>{t.trustAccessText}</p>
                            <span className="more">{t.trustAccessLink}</span>
                        </a>
                        <a className="panel rv" href={APP_URL} style={{ '--rv-delay': '180ms' }}>
                            <span className="eyebrow">{t.trustControlEyebrow}</span>
                            <h3>{t.trustControlTitle}</h3>
                            <p>{t.trustControlText}</p>
                            <span className="more">{t.trustControlLink}</span>
                        </a>
                    </div>
                </div>
            </section>
            <section className="home-sec">
                <div className="wrap">
                    <div className="panel nets rv">
                        <b>{t.networksTitle}</b>
                        <div className="chains" style={{ margin: 0 }}>
                            <span className="chain">
                                <i style={{ background: '#ff4d4d' }} />
                                Tron
                            </span>
                            <span className="chain">
                                <i style={{ background: '#f3ba2f' }} />
                                BNB Chain
                            </span>
                            <span className="chain">
                                <i style={{ background: '#9a6bff' }} />
                                Solana
                            </span>
                            <span className="chain">
                                <i style={{ background: '#3f7bff' }} />
                                Base
                            </span>
                            <span className="chain">
                                <i style={{ background: '#2aa4f4' }} />
                                TON
                            </span>
                            <span className="chain">
                                <i style={{ background: '#8a9ab0' }} />
                                Ethereum
                            </span>
                            <span className="chain">
                                <i style={{ background: '#37d39a' }} />
                                Card
                            </span>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default TrustSection;
